"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Event = _interopRequireDefault(require("../events/Event.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module ol/render/Event
 */
var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var RenderEvent =
/** @class */
function (_super) {
  __extends(RenderEvent, _super);
  /**
   * @param {import("./EventType.js").default} type Type.
   * @param {import("../transform.js").Transform} [opt_inversePixelTransform] Transform for
   *     CSS pixels to rendered pixels.
   * @param {import("../PluggableMap.js").FrameState} [opt_frameState] Frame state.
   * @param {?(CanvasRenderingContext2D|WebGLRenderingContext)} [opt_context] Context.
   */


  function RenderEvent(type, opt_inversePixelTransform, opt_frameState, opt_context) {
    var _this = _super.call(this, type) || this;
    /**
     * Transform from CSS pixels (relative to the top-left corner of the map viewport)
     * to rendered pixels on this event's `context`. Only available when a Canvas renderer is used, null otherwise.
     * @type {import("../transform.js").Transform|undefined}
     * @api
     */


    _this.inversePixelTransform = opt_inversePixelTransform;
    /**
     * An object representing the current render frame state.
     * @type {import("../PluggableMap.js").FrameState|undefined}
     * @api
     */

    _this.frameState = opt_frameState;
    /**
     * Canvas context. Not available when the event is dispatched by the map. For Canvas 2D layers,
     * the context will be the 2D rendering context.  For WebGL layers, the context will be the WebGL
     * context.
     * @type {CanvasRenderingContext2D|WebGLRenderingContext|undefined}
     * @api
     */

    _this.context = opt_context;
    return _this;
  }

  return RenderEvent;
}(_Event["default"]);

var _default = RenderEvent;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUlBOzs7O0FBSkE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFNQTtBQUFBO0FBQUE7RUFBMEJBO0VBQ3hCOzs7Ozs7Ozs7RUFPQSxxQkFBWUMsSUFBWixFQUFrQkMseUJBQWxCLEVBQTZDQyxjQUE3QyxFQUE2REMsV0FBN0QsRUFBd0U7SUFBeEUsWUFDRUMsa0JBQU1KLElBQU4sS0FBVyxJQURiO0lBR0U7Ozs7Ozs7O0lBTUFLLEtBQUksQ0FBQ0MscUJBQUwsR0FBNkJMLHlCQUE3QjtJQUVBOzs7Ozs7SUFLQUksS0FBSSxDQUFDRSxVQUFMLEdBQWtCTCxjQUFsQjtJQUVBOzs7Ozs7OztJQU9BRyxLQUFJLENBQUNHLE9BQUwsR0FBZUwsV0FBZjs7RUFDRDs7RUFDSDtBQUFDLENBbkNELENBQTBCTSxpQkFBMUI7O2VBcUNlQyxXIiwibmFtZXMiOlsiX19leHRlbmRzIiwidHlwZSIsIm9wdF9pbnZlcnNlUGl4ZWxUcmFuc2Zvcm0iLCJvcHRfZnJhbWVTdGF0ZSIsIm9wdF9jb250ZXh0IiwiX3N1cGVyIiwiX3RoaXMiLCJpbnZlcnNlUGl4ZWxUcmFuc2Zvcm0iLCJmcmFtZVN0YXRlIiwiY29udGV4dCIsIkV2ZW50IiwiUmVuZGVyRXZlbnQiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3JlbmRlci9FdmVudC5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==